export const MARKER_TYPE = {
  HOTEL_PRICE: 'hotel-price',
  HOTEL: 'hotel',
  VENUE: 'venue',
  CITY_CENTER: 'city-center',
  AIRPORT: 'airport',
}

export const markerTypeClasses = {
  [MARKER_TYPE.HOTEL_PRICE]: `${MARKER_TYPE.HOTEL_PRICE}-chip`,
  [MARKER_TYPE.HOTEL]: `${MARKER_TYPE.HOTEL}-chip`,
  [MARKER_TYPE.VENUE]: `${MARKER_TYPE.VENUE}-chip`,
  [MARKER_TYPE.CITY_CENTER]: `${MARKER_TYPE.CITY_CENTER}-chip`,
  [MARKER_TYPE.AIRPORT]: `${MARKER_TYPE.AIRPORT}-chip`,
}

export const markerClasses = {
  active: 'active-chip',
  size: { xs: 'marker-size-xs' },
  ...markerTypeClasses,
}

export const markerZindex = {
  [MARKER_TYPE.VENUE]: 10,
  [MARKER_TYPE.AIRPORT]: 1,
  [MARKER_TYPE.CITY_CENTER]: 2,
  [MARKER_TYPE.HOTEL]: 3,
}
